import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { HeadingTwo, Button } from "../elements"
import {
  breakpointSmall,
  breakpointLarge,
  breakpointMedium,
} from "../variables"
import { Link } from "gatsby"
import Illustration from "../components/illustration"

const TextSection = ({ slice }) => {
  const {
    alignment,
    title,
    content,
    cta_link,
    cta_content,
    content_width,
    illustration_placement,
  } = slice.primary

  const [ctaUrl, setCtaUrl] = useState()

  useEffect(() => {
    if (cta_link.url) {
      setCtaUrl(cta_link.url)
    }
    if (cta_link.slug) {
      setCtaUrl("/" + cta_link.slug)
    }
  }, [])

  return (
    <TextSectionContainer contentWidth={content_width} alignment={alignment}>
      {title && (
        <HeadingTwo margin="0 0 40px 0" fontWeight="400">
          {title.text}
        </HeadingTwo>
      )}
      <div dangerouslySetInnerHTML={{ __html: content.html }}></div>
      {ctaUrl && (
        <Link
          to={ctaUrl}
          target={cta_link.target === "_blank" ? "_blank" : "_self"}
        >
          <Button>{cta_content.text}</Button>
        </Link>
      )}
      <Illustration placement={illustration_placement} />
    </TextSectionContainer>
  )
}

export default TextSection

const TextSectionContainer = styled.section`
  text-align: ${({ alignment }) => (alignment === "left" ? "left" : "center")};
  padding: 110px 0;
  position: relative;
  overflow: hidden;
  max-width: ${({ contentWidth }) =>
    contentWidth === "large" ? "1229px" : "875px"};
  margin: 0 auto;
  width: 90%;

  p {
    font-size: 18px;
    line-height: 1.48;
    margin: 0 auto 20px auto;
  }

  a,
  li {
    font-size: 18px;
    line-height: 1.48;
  }

  a:hover {
    color: #ffa700;
  }

  ${HeadingTwo} {
    color: #4a3c31;
    letter-spacing: 0.07em;
  }

  @media (min-width: ${breakpointSmall}) {
    ${HeadingTwo} {
      font-size: 27px;
    }
  }

  @media (min-width: ${breakpointMedium}) {
    p {
      font-size: 21px;
    }

    a,
    li {
      font-size: 21px;
    }
  }

  @media (min-width: ${breakpointLarge}) {
    ${HeadingTwo} {
      font-size: 30px;
    }

    p {
      font-size: 21px;
    }
  }
`
